/* LuvinCo product gallery: arrows, "n / N" counter, click-to-zoom. Builds on the theme's media-carousel. */
(function () {
  var ARROW_SVG = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M7.5 4.5 13 10l-5.5 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(gallery) {
    if (gallery.dataset.lgReady) return;
    var wrapper = gallery.querySelector('.product-gallery__media-list-wrapper');
    var carousel = gallery.querySelector('media-carousel');
    if (!wrapper || !carousel) return;
    gallery.dataset.lgReady = '1';

    var nav = document.createElement('div');
    nav.className = 'lg-nav';
    nav.innerHTML =
      '<button type="button" class="lg-arrow lg-arrow--prev" aria-label="Imagem anterior">' + ARROW_SVG + '</button>' +
      '<button type="button" class="lg-arrow lg-arrow--next" aria-label="Próxima imagem">' + ARROW_SVG + '</button>' +
      '<span class="lg-counter" aria-live="polite"></span>';
    nav.querySelector('.lg-arrow--prev svg').style.transform = 'scaleX(-1)';
    wrapper.appendChild(nav);

    var prev = nav.querySelector('.lg-arrow--prev');
    var next = nav.querySelector('.lg-arrow--next');
    var counter = nav.querySelector('.lg-counter');

    function visible() {
      return Array.prototype.filter.call(carousel.children, function (el) {
        return !el.hidden && el.offsetParent !== null;
      });
    }

    function step() {
      var v = visible();
      if (v.length < 2) return carousel.clientWidth;
      return v[1].offsetLeft - v[0].offsetLeft;
    }

    function update() {
      var v = visible();
      nav.hidden = v.length < 2;
      wrapper.classList.toggle('lg-single', v.length < 2);
      if (v.length < 2) return;
      var index = Math.min(v.length - 1, Math.max(0, Math.round(carousel.scrollLeft / step())));
      var max = carousel.scrollWidth - carousel.clientWidth;
      counter.textContent = (index + 1) + ' / ' + v.length;
      prev.disabled = carousel.scrollLeft <= 2;
      next.disabled = carousel.scrollLeft >= max - 2;
    }

    function go(dir) {
      carousel.scrollBy({ left: dir * step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    carousel.addEventListener('scroll', update, { passive: true });
    carousel.addEventListener('carousel:select', update);
    carousel.addEventListener('carousel:filter', function () { setTimeout(update, 50); });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 400);

    // Clicking an image opens the zoom (replaces the theme's click-to-navigate on desktop)
    gallery.addEventListener('click', function (event) {
      var slide = event.target.closest('.product-gallery__media');
      if (!slide || !carousel.contains(slide) || event.target.closest('button, a[href]')) return;
      if (slide.getAttribute('data-media-type') !== 'image' || !gallery.hasAttribute('allow-zoom')) return;
      event.stopPropagation();
      var images = Array.prototype.filter.call(carousel.children, function (el) {
        return !el.hidden && el.getAttribute('data-media-type') === 'image';
      });
      gallery.openZoom(Math.max(0, images.indexOf(slide)));
    }, true);
  }

  function init() {
    customElements.whenDefined('media-carousel').then(function () {
      document.querySelectorAll('product-gallery').forEach(setup);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
